import store from './reduxStore';

const isLoggedIn = () => store.getState().user.isAuthenticated;

export const isOnboarded = () => store.getState().onboarding.onboarded;

export default isLoggedIn;
